import { mapState } from 'vuex'

export default {
  name: 'LiveClock',
  props: {
    format: {
      type: String,
      default: 'HH:mm'
    }
  },
  computed: {
    ...mapState({
      sharedTime: state => state.sharedTime.time
    })
  }
}